import { render } from "./AddStudentList.vue?vue&type=template&id=88910f6e"
import script from "./AddStudentList.vue?vue&type=script&lang=js"
export * from "./AddStudentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__